import React, { useState } from "react";
import { Expand } from "lucide-react";
import { mediaSrc } from "@/lib/api";
import Lightbox from "@/components/Lightbox";

/**
 * Per-discipline gallery: ONE dominant image that opens the immersive
 * Lightbox (no thumbnail grid). A discreet count badge signals how many
 * images are available; navigation happens inside the viewer via swipe/arrows.
 */
export default function DisciplineGallery({ images = [], alt = "Discipline work", testId }) {
  const clean = (images || []).filter((u) => typeof u === "string" && u.trim());
  const [open, setOpen] = useState(false);

  if (clean.length === 0) {
    return <div className="w-full h-[300px] md:h-[420px] bg-lux-line" data-testid={testId} />;
  }

  return (
    <div data-testid={testId}>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid={`${testId}-open`}
        className="relative block w-full h-[300px] md:h-[460px] overflow-hidden bg-lux-line group"
        aria-label={`Open gallery — ${clean.length} image${clean.length > 1 ? "s" : ""}`}
      >
        <img
          src={mediaSrc(clean[0])}
          alt={alt}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
        />
        <span className="absolute top-3 right-3 w-9 h-9 rounded-full bg-black/50 backdrop-blur-sm flex items-center justify-center text-white">
          <Expand size={15} strokeWidth={1.6} />
        </span>
        {clean.length > 1 && (
          <span className="absolute bottom-3 left-3 px-2.5 py-1 bg-black/50 backdrop-blur-sm text-white text-[10px] tracking-[0.25em] tabular-nums">
            01 / {String(clean.length).padStart(2, "0")}
          </span>
        )}
      </button>
      {open && (
        <Lightbox images={clean} startIndex={0} alt={alt} onClose={() => setOpen(false)} testId={`${testId}-lightbox`} />
      )}
    </div>
  );
}
